import { render } from "./Employee_Rewards.vue?vue&type=template&id=2896cf1a"
import script from "./Employee_Rewards.vue?vue&type=script&lang=js"
export * from "./Employee_Rewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__